import { TApplicationState } from '../../types/redux';

export const selectFormRequirements = (state: TApplicationState) => state.requestFormV2.form.requirements;
